/* eslint-disable jira/filename-case */

// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import { useIsClientReady } from '@jira/ssr__ssr-toolkit/src/useIsClientReady.tsx';
import Store from '../../store.tsx';
import type { State } from '../../types.tsx';

type IsReadySelectorType = {
	isReady: boolean;
};

export const isReadySelector = ({ currentPage }: State): IsReadySelectorType => {
	const { apps } = currentPage;
	const appIds = Object.keys(apps);
	return {
		isReady: appIds.length ? appIds.every((id) => apps[id].endTime || apps[id].timeoutTime) : false,
	};
};

const useSpaStatePageReadyStateHook = createHook(Store, {
	selector: isReadySelector,
});

export function useSpaStatePageReady(): boolean {
	const isClientReady = useIsClientReady();
	const [{ isReady }] = useSpaStatePageReadyStateHook();
	return isClientReady && isReady;
}
